import * as $dbSRa$react from "react";
const DynamicTagComponent = ({
  children = "Dynamic tag component",
  tag = "button",
  ...props
}) => $dbSRa$react.createElement(tag, { ...props }, children);
export {
  DynamicTagComponent as default
};
//# sourceMappingURL=index.es.js.map
